<div class="columns">
  <div class="column is-6-desktop is-4-fullhd">
    <div class="box">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="wo-account-title">
            <iss-icon [name]="'users'" />
            Account details
          </div>
        </div>
        <iss-form-field class="column is-12" [showNecessity]="false">
          <iss-label>Login</iss-label>
          <tui-input
            [ngModel]="email$ | async"
            [tuiTextfieldLabelOutside]="true"
            [disabled]="true"
          >
            <input tuiTextfield />
          </tui-input>
        </iss-form-field>
        <div class="column is-12">
          <iss-form-field [showNecessity]="false">
            <iss-label>Password</iss-label>
            <tui-input
              [ngModel]="email$ | async"
              [tuiTextfieldLabelOutside]="true"
              [disabled]="true"
            >
              <input type="password" tuiTextfield />
            </tui-input>
          </iss-form-field>
          <div class="wo-account__link" *ngIf="resetPasswordLink">
            <a [href]="resetPasswordLink" rel="noopener noreferrer">Change password</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="column is-6-desktop is-8-fullhd" *ngIf="!production">
    <div class="box">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="wo-account-title">
            <iss-icon [name]="'system-action'" />
            Permissions
          </div>
        </div>
        <div class="column is-12">
          <div class="wo-account-permissions">
            <tui-tag
              *ngFor="let permission of permissions$ | async"
              size="s"
              [value]="permission"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #title>
  <wo-account-title
    [name]="username$ | async"
    [roles]="roles$ | async"
  />
</ng-template>
